import {metadaApi} from '@dms/api/base';

import {
  GetServiceOrderByRentalOrderIdApiArg,
  GetServiceOrderByRentalOrderIdApiResponse,
} from './types';

export const metadaRentalOrderApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceOrderByRentalOrderId: build.query<
      GetServiceOrderByRentalOrderIdApiResponse,
      GetServiceOrderByRentalOrderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/integration/v1/rental-order/${queryArg.rentalOrderId}/service-order`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceRentalOrder', id: queryArg.rentalOrderId},
      ],
    }),
  }),
});

export const {useGetServiceOrderByRentalOrderIdQuery} = metadaRentalOrderApi;
